'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable camelcase */
function ProvideConsent() {
  var _this = this;

  this.extends = [_AccountController];
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this._onFormSubmitCallback = null;
  this.formAction = 'account.edit_member';

  this.init = function () {
    this._super();

    // failed min reqs or completed steps in this set
    if (!this.hasVerifiedEmail() || this.hasProvidedConsent() || !this.hasAddress()) {
      this.routeToNextStep();
      return;
    }

    this.analytics.pushEvent('virtual-page-view');

    this._$node = $(this.node);
    this._$form = this._$node.find('.js--onboarding-form')[0];

    // Form inputs
    this._$formInputs = {
      // Credit check consent
      creditCheckOptIn: this._$node.find('.js--credit-check-group'),
      // ToolTip
      creditCheckConsentTooltip: this._$node.find('.js--score-info'),
      submit: this._$node.find('.js--form-submit')
    };

    // Field specific setup:
    this._setupConsent();
    this._loadConsentChanges();

    this._$portal = $('#Portal');
    this._$portal.mogo().setupTargetAudience();

    this._onFormSubmitCallback = this.presenter.addCallbackToAction(this.formAction, this.onFormSubmittedCallback.bind(this));
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    if (this._$form) {
      // cleanup required object so its ready for the next screen
      delete this._$form.mogo().schema.required;
      if (this._onFormSubmitCallback) {
        this.presenter.removeCallbackFromAction(this.formAction, this._onFormSubmitCallback);
      }
    }
    this.presenter.removeComputedVariable('profile_info_theme');
  };

  this.onFormSubmittedCallback = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage(this._$form, {
        productLabel: 'MogoMember'
      });
    } else if (response === 200) {
      var formAnalyticsID = $('.js--onboarding-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this.presenter.models.account.updateModel(data, this.onCompletedStep.bind(this, data));
    } else {
      if (data.errors) {
        console.log('Error validating data on BE', data.errors);
        this.analytics.forcePushEvent('generic-push-event', {
          event: ['SetProfileErrors']
        });
        // this._$form.form.mogo().parseErrorObject(data.errors);
      }
      $('#Notification').mogo().get();
    }
  };

  this.onCompletedStep = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
      var _window, analytics, credit_check_opt_in, analyticsData, analyticsRequest;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Segment Analytics
              _window = window, analytics = _window.analytics;
              credit_check_opt_in = data.credit_check_opt_in;
              _context.prev = 2;
              _context.next = 5;
              return analytics.track('Account Updated', { credit_check_opt_in: credit_check_opt_in });

            case 5:
              _context.next = 7;
              return analytics.track('Flow Completed', {
                flow_id: 'onboarding',
                product_id: 'mogo',
                screen_name: 'onboarding provide consent'
              });

            case 7:
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](2);

              console.warn('>>> Error: ' + _context.t0);

            case 12:

              // send analytics to SOA on final step only
              // this would always be the last step if it happens...
              // if (this.hasCompletedOrCanSkipAdditionalInfo()) {
              analyticsData = this.analytics.constructData('Complete Profile');
              analyticsRequest = new APIRequest('/analytics', 'POST', analyticsData, null);

              analyticsRequest.send();
              // }

              this.routeToNextStep(); // _OnboardingCoordinator

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this._setupConsent = function () {
    if (this._$formInputs.creditCheckConsentTooltip.length) {
      // Set consent to checked if user comes back after save
      if (this.presenter.getModelProperty('account.credit_check_opt_in') != null) {
        this.presenter.setModelProperty('account.credit_check_opt_in_preselect', true);
      }

      this._$formInputs.creditCheckConsentTooltip.on('mouseover', this.pushTooltipAnalytics.bind(this));
    }
  };

  this._setupCheckbox = function (placeholder, error) {
    _this._$checkBox = _this._$node.find('.js--form-credit-check-opt-in');
    _this._$checkBoxGroup = _this._$node.find('.js--credit-check-group');
    _this._$checkBox.mogo().create('Checkbox', { placeholder: placeholder });
    _this._$checkBoxGroup.mogo().create('BooleanGroup', {
      name: 'credit_check_opt_in',
      required: 'true',
      error: error,
      type: 'Boolean'
    });
  };

  this._loadConsentChanges = function () {
    var products_of_interest = _this.presenter.models.account.products_of_interest;

    var headerEl = document.querySelector('.js--form-profile-info .header__content > h1');
    var buttonEl = document.querySelector('.js--onboarding-form button');
    var creditCheckOptInCheckbox = document.querySelector('.js--form-credit-check-opt-in');

    if (products_of_interest) {
      var placeholder = 'I consent to Mogo using my personal information to get a credit score or report from a credit reporting agency now and on a monthly basis for the purposes of providing me with my free credit score and determining whether I am pre-approved for MogoMoney offers, which I am not obligated to take in order to get my credit score. I’m aware that these initial and ongoing credit and bureau checks will not impact my credit score, which is pretty sweet.';
      var error = 'Tick this box so that we can show you your credit score!';
      var isInterestedInLoan = products_of_interest.includes('loan');

      if (isInterestedInLoan) {
        _this.presenter.addComputedVariable('profile_info_theme', ['account'], function () {
          return 'money';
        });
      } else {
        // note: Shows new consent screen that has no checkbox.
        headerEl.textContent = "You're nearly there!";
        buttonEl.textContent = 'Next';
        creditCheckOptInCheckbox.checked = true; // This is required for the form to submit.
      }
      _this._setupCheckbox(placeholder, error);
    }
  };

  this.pushTooltipAnalytics = function () {
    this.analytics.pushEvent('tooltip', { tooltipContent: ['Credit Check Consent'] });
  };
}